import defineCustomElement from './defineCustomElement.bea6.js'
import cartGlobalStore from './cartGlobalStore.4268.js'

defineCustomElement('md-cart-contents', (el) => {
  const ac = new AbortController()

  const reload = async () => {
    const html = await fetch('/cart?view=contents', { signal: ac.signal }).then(res => res.text())
    if(ac.signal.aborted) return
    el.outerHTML = html
  }

  const submitFormData = async (body, endpoint = '/cart/update') => {
    el.classList.add('opacity-50')

    // /cart/update seems to be same as /cart and /cart.js
    // /cart/change seems to be a line item mutation
    await fetch(endpoint, {
      method: 'post',
      body,
      headers: {
        // needed for /cart/change
        accept: 'application/json'
      },
      redirect: 'manual',
      signal: ac.signal
    }).then(res => {
      if(!res.ok) {
        res.json().then(console.warn) // debug
      }
      // with { accept: 'text/html' } will return a 302
      reload()
      // tell out global cart store to refresh
      cartGlobalStore.refresh()
    })
  }

  /** @type {HTMLElement | undefined} */
  const form = el.querySelector('form')

  /** if form doesn't exist load it. This allows to lazy load with
   * just adding this element to page
   * <md-cart-contents></md-cart-contents>
   * */
  if(!form) {
    reload()
    return
  }

  form.addEventListener('submit', (e) => {
    if(e.submitter?.name === 'checkout') {
      return
    }

    const body = new FormData(e.target)
    e.preventDefault()
    submitFormData(body)
  })

  /** quantity or delete links a[href="/cart/change" ]*/
  form.addEventListener('click', (e) => {
    if(!getIsPlainClickEvent(e)) return
    const link = getAnchorFromMouseEvent(e)

    if(!link || link.origin !== window.location.origin) return
    if(!link.pathname.includes('/cart/change') && !link.pathname.includes('/cart/update')) return
    const body = new FormData()
    new URL(link.href).searchParams.forEach((value, key) => {
      body.append(key, value)
    })
    e.preventDefault()
    submitFormData(body, link.pathname)
  })

  /** quantity input change  by user*/
  form.addEventListener('focusout', () => {
    submitFormData(new FormData(form))
  })

  /** teardown */
  return () => {
    ac.abort()
  }
})

const getIsPlainClickEvent = (/** @type {MouseEvent}*/e) => {
  if (e.defaultPrevented) return false
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false
  return true
}
const getAnchorFromMouseEvent = (/** @type {MouseEvent}*/e) => {
  const el = e.target
  return el instanceof HTMLAnchorElement ? el : el instanceof Element ? el.closest('a') : null
}

